import { Box, FormControl, FormLabel, Grid, Skeleton, TextField, Typography } from "@gvdasa/react-components";
import { memo } from "react";
interface IAcoordionNomePerfil {
  isLoading: boolean,
  Nome: string,
  setNome: (event) => void,
  erroPerfil: boolean,
  textoDeErroNome: string,
  disabled: boolean
}

export const AccordionNomePerfil: React.FC<IAcoordionNomePerfil> = memo(({
  isLoading,
  Nome,
  setNome,
  erroPerfil,
  textoDeErroNome,
  disabled

}) => {


  return (
    <Box marginBottom={3}>
      <Typography variant="h5" fontFamily="roboto" color="primary" fontWeight="bold" marginBottom={2}>Dados gerais</Typography>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-start"
      >
        <Grid size={12}>
          {!isLoading && (
            <FormControl data-testid="teste-nome" margin="none" fullWidth >
              <FormLabel required >Perfil</FormLabel>
              <TextField
                disabled={disabled}
                margin="none"
                required
                autoFocus
                value={Nome}
                onChange={(event) => setNome(event.target.value)}
                variant="outlined"
                error={erroPerfil}
                helperText={textoDeErroNome}
              />
            </FormControl>
          )}
          {isLoading && <Skeleton height={70} />}
        </Grid>
      </Box>
    </Box>
  )
})